module.exports = __webpack_public_path__ + "static/ruslan-39a21e56ccc43c99ed43cea22db491d3.mp3";